module.exports = __webpack_public_path__ + "img/img87.54ee1b1b.png";